var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9056 9.75277L9.09155 3.8799C9.09155 3.8799 10.2493 3.34619 11.9975 3.34619C13.7478 3.34619 14.9035 3.81056 14.9035 3.81056V9.75277H14.9056Z",
    fill: "#FC6B4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5798 12.4739L15.6219 4.21191C15.6219 4.21191 16.8174 4.65317 18.0551 5.89078C19.2927 7.12839 19.7823 8.27565 19.7823 8.27565L15.5798 12.4739Z",
    fill: "#7838F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1558 14.9322L20.0286 9.11816C20.0286 9.11816 20.5623 10.2759 20.5623 12.0241C20.5623 13.7723 20.098 14.9301 20.098 14.9301H14.1558V14.9322Z",
    fill: "#5698F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.468 15.6887L19.73 15.7307C19.73 15.7307 19.2887 16.9263 18.0511 18.1639C16.8135 19.4016 15.6662 19.8911 15.6662 19.8911L11.468 15.6887Z",
    fill: "#20E9F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09155 14.2998L14.9056 20.1727C14.9056 20.1727 13.7478 20.7064 11.9996 20.7064C10.2514 20.7064 9.09365 20.242 9.09365 20.242V14.2998H9.09155Z",
    fill: "#00FD60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41701 11.5786L8.37499 19.8406C8.37499 19.8406 7.1794 19.3993 5.94179 18.1617C4.70418 16.9241 4.2146 15.7768 4.2146 15.7768L8.41701 11.5786V11.5786Z",
    fill: "#ABFB5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84164 9.12012L3.96877 14.9321C3.96877 14.9321 3.43506 13.7743 3.43506 12.0261C3.43506 10.2779 3.89943 9.12012 3.89943 9.12012H9.84164Z",
    fill: "#F0E254"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5293 8.36154L4.26733 8.31952C4.26733 8.31952 4.70859 7.12393 5.9462 5.88632C7.18381 4.64871 8.32897 4.16333 8.32897 4.16333L12.5293 8.36154Z",
    fill: "#F6B351"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTimeline);
export default __webpack_public_path__ + "static/media/share-timeline.0a341d3e.svg";
export { ForwardRef as ReactComponent };